/** Adds each item to the index unless its id is already present, so the first occurrence wins. */
export const indexFirstById = <T extends { id: number }>(
  items: readonly T[],
  index: Map<number, T> = new Map()
): Map<number, T> => {
  for (const item of items) {
    if (!index.has(item.id)) index.set(item.id, item)
  }
  return index
}
